//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  name: "videoView",
  data() {
    return {
      files: [
        {
          url: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
    ]),
    getFile() {
      console.log(this.$refs.frvideoView.fileList)
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
    'crfcode',
    'baseURL'
    ])
  },
  created() {
  },
  mounted() {
  }
};
